import React from "react";

import Loading from "ds/PageLoading";
import { selectFeatureUsageBasedBillingEnabled } from "Reducers/featureFlags/featureFlags.selectors";
import {
  useIsLoadingSubscription,
  useUrlParamsSubscription
} from "Reducers/organization/subscription/hooks";
import useBlackFireSellableStatus from "src/organization/pages/project/containers/ProjectOverview/BlackfireCard/useBlackFireSellableStatus";
import { useAppSelector } from "Store/hooks";

import ObservabilitySuiteUpgrade from "./components/ObservabilitySuiteUpgrade";
import Profiling from "./Profiling";

const Page = () => {
  const isUsageBilling = useAppSelector(selectFeatureUsageBasedBillingEnabled);
  const subscription = useUrlParamsSubscription();
  const isLoading = useIsLoadingSubscription();

  const isObs =
    useBlackFireSellableStatus(subscription).observabilitySuitePurchased;
  const isUsageBilledOrHasObs = isUsageBilling || isObs;

  if (!subscription && isLoading) return <Loading />;

  return isUsageBilledOrHasObs ? <Profiling /> : <ObservabilitySuiteUpgrade />;
};

export default Page;
